import axios from "axios";

export default function UserRegistrationConfirmService(formData) {

  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/registration/check",
    data: formData,
    params: {},
    headers: {}
  });
}
